// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dropdown-link {\n  cursor: pointer;\n  color: #2c6dd2;\n  font-size: 12px;\n}\n.el-icon-arrow-down {\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
